import { OfferKindEnum } from '../../../../../services/exports/Constants';

const OfferBadge: Partial<Record<OfferKindEnum, string>> = {
  [OfferKindEnum.PercentageOffByMinSpendValue]: 'Lisäalennus {{percentageAmount}} %',
  [OfferKindEnum.PercentageOffByProducts]: 'Lisäalennus {{percentageAmount}} %',
  [OfferKindEnum.AmountOffByProducts]: 'Lisäalennus {{amount}}',
  [OfferKindEnum.Bogo]: '2 HINNALLA 1',
  [OfferKindEnum.BogoHalfPrice]: 'Osta 1, saat 1 puoleen hintaan!',
  [OfferKindEnum.FreeItemByProducts]: 'Ilmainen tuote',
  [OfferKindEnum.FreeItemByMinSpendValue]: 'Ilmainen tuote',
};

export default OfferBadge;
